export class UpdateOrderRequirements {
  missingProducts: boolean;
  supportToDropOff: boolean;

  public constructor(missingProducts: boolean, supportToDropOff: boolean) {
    this.missingProducts = missingProducts;
    this.supportToDropOff = supportToDropOff;
  }
}